import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
// const useEnv = 'development'
//  const baseUrl= 'http://8.129.188.160:8883'



  const useEnv = 'development'
  // const baseUrl= 'http://localhost:8086' 
  // const baseUrl= 'http://192.168.0.102:8086' 
  //  const baseUrl= 'http://192.168.1.46:8086'
  // const baseUrl= 'http://192.168.43.100:8086'//手机热点
  // const baseUrl= 'http://49.234.134.19:8086' //曹总本地useEnv
// const useEnv = 'production'
// const baseUrl= 'https://chengyi.cherishinlove.cn/admin/' 

  const baseUrl= 'https://ebonds.zzrh.com.cn/admin/'




// localStorage.setItem("baseUrl",baseUrl+'/api')
localStorage.setItem("baseUrl",baseUrl)

localStorage.setItem("useEnv",useEnv)
// 创建axios实例 正式
let service
if(useEnv=='production'){
  localStorage.setItem("upload",baseUrl+"/front/api/uploadFileOss")
   service = axios.create({
    baseURL: baseUrl+'/api', // api的测试的base_url
    timeout: 18000 // 请求超时时间
  })
}else{
  localStorage.setItem("upload","https://backjavatest.cherishinlove.cn/api/uploadFileOss")
  service = axios.create({
    baseURL: baseUrl, // api的测试的base_url
    timeout: 18000 // 请求超时时间
  })
}




// service.interceptors.request.use(config => {
//   console.log(config)
// })

// respone拦截器
service.interceptors.response.use(
  response => {
    console.log(response)
    const res = response.data
    if(!res.code && res.code !=0){
      return response.data
      // MessageBox.confirm('401,你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      //   confirmButtonText: '重新登录',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //     sessionStorage.setItem("user", "");
      //     store.commit('logout', 'false')
      //     location.reload()
      // })
    }else if (res.code != 200) {
         // // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            sessionStorage.setItem("user", "");
            sessionStorage.setItem('uid',"")
            sessionStorage.setItem('username',"")
            store.commit('logout', 'false')
            location.reload()
            // this.$router.push({ path: '/login' })
        //   store.dispatch('logout').then(() => {  
        //     location.reload()
        //   })
        })
      }
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })
      if(res.code ==403 || response.code ==403){
        return response
      }else{
        return Promise.reject(res.message)
      }
   
    }  else {
     
      return response
    }



  },
  error => {
   
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
